import styled from 'styled-components'
import Text from '../atoms/Text'
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
`
const WordWrapper = styled.div`
  text-align: left;
`
const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`
const BookmarkOffIcon = styled(BookmarkBorderOutlinedIcon)`
  color: ${(props) => props.theme.colors.secondary};
`
const BookmarkOnIcon = styled(BookmarkOutlinedIcon)`
  color: ${(props) => props.theme.colors.secondary};
`

const WordItem = ({item, onToggle, onClickItem}) => {
  return (
    <Container onClick={onClickItem}>
      <WordWrapper>
        <Text as="p" weight="medium">{item.kr_transcript}</Text>
        <Text as="p" weight="body2" color="alternative">{item.ipa}</Text>
        <Text as="p" variant="body2" color="alternative">{item.meaning}</Text>     
      </WordWrapper>
      {/* <IconButton 
        onClick={(e) => {
          e.stopPropagation();
          onToggle(item.id)
        }}>
        {item.isBookmark ? <BookmarkOnIcon/> : <BookmarkOffIcon/>}
      </IconButton> */}
    </Container>
  )
}

export default WordItem
